import {stateData, reduxState} from '../../values';

export const getVehicles = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.get_vehicles,
            payload:    data.Data,
            status:     stateData.state2,
            records:    data.Records
        })
    }
}

export const updateVehicles = (data) =>{
    return(dispatch) =>{
        dispatch({
            type:       reduxState.update_vehicles,
            payload:    data,
        })
    }
}